import { withForm } from '@components/ui/form/form';
import { isResearchType } from '@utils/company.util';
import { DetailsCommercialSection } from './company-company-profile-modal-details-commercial-section.component';
import { DetailsResearchSection } from './company-company-profile-modal-details-research-section.component';
import { companyProfileModalDetailsAdditionalDefaultProps } from './company-company-profile-modal-details.types';
import { companyFormOptions } from './company-form-options';

export const DetailsStep = withForm({
  ...companyFormOptions,
  props: companyProfileModalDetailsAdditionalDefaultProps,
  render: function Render(props) {
    const { form } = props;

    return (
      <form.AppForm>
        <form.Subscribe selector={(state) => state.values.type}>
          {(companyType) =>
            isResearchType(companyType) ? (
              <DetailsResearchSection {...props} />
            ) : (
              <DetailsCommercialSection {...props} />
            )
          }
        </form.Subscribe>
      </form.AppForm>
    );
  },
});
